exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-login-tsx": () => import("./../../../src/pages/login.tsx" /* webpackChunkName: "component---src-pages-login-tsx" */),
  "component---src-pages-markdown-remark-frontmatter-url-js": () => import("./../../../src/pages/{MarkdownRemark.frontmatter__url}.js" /* webpackChunkName: "component---src-pages-markdown-remark-frontmatter-url-js" */)
}

